/* eslint-disable no-loop-func */
/* eslint-disable no-await-in-loop */
/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Dropdown,
  Divider,
  Grid,
  Container,
  Loader,
  Button,
  TextArea,
  Checkbox
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import map from 'lodash/map';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';
import mapKeys from 'lodash/mapKeys';

import {
  getMonthFromCampaign,
  getYearFromCampaign,
  replaceYearAndMonth,
  isNullOrUndefined
} from './utils';

import {
  getCampaignsWithoutAdsets,
  copyCampaign,
  getCampaign,
  getCampaignWithPromotedObjects,
  updateCampaign
} from '../../fbApi/Campaign';
import { getAdSet, updateAdSet, copyAdSet } from '../../fbApi/AdSet';
import { getAd, updateAd, copyAd } from '../../fbApi/Ad';
import { clearFbCacheInLocalStorage } from '../../fbApi/fbCallManager';
import months from '../../utils/months';
import { getLastDateForUpcomingMonth } from '../../utils/dates';
import { formatDateTime } from '../../utils/format';
import { getRawAdName } from '../../utils/ad.common';
import { getAccounts, refreshAccounts } from '../../services/AccountService';
import { updateUrl } from '../../utils/urls';
import { getAdLineageByAdId, insertAdLineage } from '../../utils/ad.lineage';
import './FlipperSync.css';

class FlipperSync extends Component {
  state = {
    validCampaignSelection: true,
    campaignsFilterFormats: {},
    data: null,
    paging: null,
    summary: null,
    accountOptions: null,
    adAccountName: null,
    adAccountId: null,
    campaignName: null,
    campaignIds: null,
    selectedCampaigns: [],
    accounts: null,
    done: false,
    selectedYear: '',
    showYearSelector: false,
    showYearLoader: false,
    years: [],
    formatSelected: null,
    showMonthSelector: false,
    showCampaignSelector: false,
    months: [],
    processing: false,
    existentCopies: false,
    processingText: '',
    showMonthLoader: false,
    showCampaignsLoader: false,
    showFlipperButton: false,
    notCleanLog: false,
    logText: '',
    warnings: '',
    errors: '',
    campaignFormats: {
      PRODUCT_CATALOG_SALES: 'Dynamic Ads',
      LEAD_GENERATION: 'Lead Ads',
      VIDEO_VIEWS: 'Video Ads',
      LINK_CLICKS: 'Traffic Ads',
      CONVERSIONS: 'Site Visits',
      POST_ENGAGEMENT: 'Post Engagement',
      OUTCOME_TRAFFIC: 'Outcome Traffic',
      OUTCOME_SALES: 'Outcome Sales'
    },
    allCampaigns: [],
    token: this.props.getFbToken(),
    nextStepFlipperAds: {
      sourceAds: [],
      targetAds: []
    },
    showNextMonthYear: false,
    selectedMonth: {},
    newSelectedMonth: null,
    newSelectedYear: null,
    filteredMonths: [],
    newLineage: false,
    isDeleteAdsToggleChecked: false
  };

  componentDidMount() {
    this.props.setSectionTitle('Flipper');
    this.props.saveGTMEvent('Flipper', 'Flipper');
    this.getAdAccounts().then(() => {
      this.preSelectFields();
    });
  }

  refreshAccounts = async () => {
    this.setState(
      (...prevState) => ({
        ...prevState,
        refreshAccountsLoading: true
      }),
      async () => {
        clearFbCacheInLocalStorage();
        await this.updateAdAccounts();
        await this.preSelectFields();
        this.setState((...prevState) => ({
          ...prevState,
          refreshAccountsLoading: false
        }));
      }
    );
  };

  preSelectFields = async () => {
    const url = window.location.href;
    const urlParts = url.split('#');

    if (!urlParts[1]) {
      return;
    }

    const params = urlParts[1].split('&');
    const selectedAccount = find(
      params,
      (p) => p && p.indexOf('account=') !== -1
    );

    if (selectedAccount) {
      const accountValue = selectedAccount
        .split('=')[1]
        .replace(new RegExp('%20', 'g'), ' ');
      if (!accountValue) return;
      const account = find(
        this.state.accounts,
        (a) => a.name && a.name.indexOf(accountValue) !== -1
      );

      if (account) {
        const campaigns = await this.selectAccount(
          account.account_id,
          account.name
        );
        const selectedYear = find(
          params,
          (p) => p && p.indexOf('year=') !== -1
        );

        if (selectedYear) {
          const yearValue = selectedYear
            .split('=')[1]
            .replace(new RegExp('%20', 'g'), ' ');
          if (!yearValue) return;
          this.selectYear(yearValue);
          const selectedMonth = find(
            params,
            (p) => p && p.indexOf('month=') !== -1
          );

          if (selectedMonth) {
            const monthValue = selectedMonth
              .split('=')[1]
              .replace(new RegExp('%20', 'g'), ' ');
            if (!monthValue) return;
            const month = find(
              campaigns,
              (c) => c.text && c.text.indexOf(monthValue) !== -1
            );
            this.selectMonth(month, month.text);
            if (month.text === 'December') {
              const newSelectedYear =
                parseInt(this.state.newSelectedYear, 10) + 1;
              this.setState({ newSelectedYear: newSelectedYear.toString() });
            }
          }
        }
      }
    }
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts(this.props.user.groups[0]);

      const accountOptions = sortBy(
        map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      console.log('Error in getAdAccounts(Flipper):', error);
    }
  };

  updateAdAccounts = async () => {
    try {
      const result = await refreshAccounts(this.props.user.groups[0]);

      const accountOptions = sortBy(
        map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      console.log('Error in updateAdAccounts(Flipper):', error);
    }
  };

  selectAccount = (accountId, accountName) => {
    this.setState({
      adAccountId: accountId,
      adAccountName: accountName,
      showFlipperButton: false,
      formats: null,
      campaignName: null,
      campaignIds: null,
      formatSelected: null,
      showCampaignSelector: false,
      selectedYear: '',
      showMonthSelector: false,
      showNextMonthYear: false,
      filteredMonths: [],
      newLineage: false
    });

    this.cleanLog();
    return this.getCampaigns(accountId);
  };

  onAccountSelect = (event, data) => {
    const account = find(data.options, (option) => {
      return option.value === data.value;
    });
    const accountId = account.value;
    const accountName = account.text;
    updateUrl(accountName, '', '');
    this.selectAccount(accountId, accountName);
  };

  selectYear = (value) => {
    const filteredCampaigns = this.state.campaigns.filter((val) => {
      return val.year === value;
    });
    const filteredMonths = this.state.months.filter((m) => m.year === value);
    this.setState({
      showMonthSelector: true,
      showMonthLoader: false,
      filteredCampaigns,
      selectedYear: value,
      campaignName: '',
      newSelectedMonth: null,
      newSelectedYear: value,
      filteredMonths
    });
  };

  onYearSelect = (event, data) => {
    this.setState({
      showCampaignSelector: false,
      showNextMonthYear: false,
      newLineage: false
    });

    this.cleanLog();

    const value = data.value;
    updateUrl(this.state.adAccountName, value, '');
    this.selectYear(value);
  };

  selectMonth = (month, selectedMonth) => {
    const { getFbToken } = this.props;
    const { campaignsIds, text: selectedMonthText } = selectedMonth || {};
    this.setState(
      {
        ...this.state,
        showCampaignsLoader: true,
        showCampaignSelector: false,
        showNextMonthYear: false,
        selectedMonth,
        newLineage: false
      },
      async () => {
        const { adAccountId, selectedCampaigns } = this.state;
        await this.queryCampaigns(adAccountId);
        let campaign = find(selectedCampaigns, (option) => {
          return option.value.indexOf(campaignsIds) !== -1;
        });

        campaign = month || campaign;
        const monthName = month ? selectedMonth : selectedMonthText;

        const token = getFbToken();
        await this.getCampaignForMonth(campaign.value.split(','), token);
        const currentMonth = months.find(
          (travsersedMonth) =>
            travsersedMonth.monthName === monthName ||
            travsersedMonth.shortName === monthName.substring(0, 3) ||
            monthName
              .toLowerCase()
              .includes(travsersedMonth.shortName.toLowerCase())
        );
        let nextMonth = 1;
        try {
          if (currentMonth.monthNumber !== 12) {
            nextMonth = currentMonth.monthNumber + 1;
          }
        } catch (error) {
          toast.warn('The Campaign does not match with calendar months.', {
            position: 'top-center',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false
          });
        }

        const newSelectedMonth = months.find(
          (travsersedMonth) => travsersedMonth.monthNumber === nextMonth
        );
        const { monthName: newSelectedMonthName } = newSelectedMonth || {};
        this.setState({
          ...this.state,
          showFlipperButton: true,
          campaignName: campaign.text,
          campaignIds: campaign.value,
          showCampaignsLoader: false,
          showCampaignSelector: true,
          formatSelected: null,
          showNextMonthYear: true,
          newSelectedMonth: {
            value: newSelectedMonthName || null,
            text: newSelectedMonthName || '',
            monthObj: newSelectedMonth || {},
            key: newSelectedMonthName || ''
          }
        });

        this.cleanLog();
      }
    );
  };

  onCampaignSelect = async (event, { options, value }) => {
    const { adAccountName, selectedYear } = this.state;
    const selectedMonth = find(options, (option) => {
      return option.value === value;
    });
    updateUrl(adAccountName, selectedYear, selectedMonth.text);
    this.selectMonth(null, selectedMonth);

    if (selectedMonth.value === 'December') {
      const newSelectedYear = parseInt(selectedYear, 10) + 1;
      this.setState({ newSelectedYear: newSelectedYear.toString() });
    } else {
      this.setState({ newSelectedYear: selectedYear });
    }
  };

  onFormatSelect = (event, data) => {
    const format = data.options.find((option) => option.value === data.value);
    let existentCopies;

    // check if selected campaign type is already copied
    const campaigns = this.state.allCampaigns.filter(
      (campaign) => campaign.name.indexOf(format.name) !== -1
    );
    if (campaigns.length) {
      existentCopies = campaigns.find(
        (campaign) => campaign.name.indexOf('Copy') !== -1
      );
    } else {
      existentCopies = this.state.allCampaigns.find(
        (campaign) => campaign.name.indexOf('Copy') !== -1
      );
    }

    this.setState({
      formatSelected: format.value,
      existentCopies
    });

    this.cleanLog();
  };

  getCampaignForMonth = async (campaignIds, token) => {
    let existentCopies = false;
    const campaignDropdowns = {
      formats: []
    };

    this.setState({
      ...this.state,
      showCampaignsLoader: true,
      showCampaignSelector: false
    });
    const { campaignFormats, notCleanLog, logText } = this.state;
    const allCampaigns = await Promise.all(
      map(campaignIds, async (campaignId) => {
        const campaign = await getCampaignWithPromotedObjects(
          campaignId,
          token
        );

        if (campaign && !campaign.adsets) {
          return Promise.resolve(null);
        }

        const {
          id: campaignIdFromCall,
          name: campaignName,
          adsets,
          objective
        } = campaign;

        const campAdsets = await adsets.data.map((adset) => {
          const { id: adsetId, name: adsetName } = adset;
          return {
            name: getRawAdName(adsetName),
            id: adsetId,
            selected: true
          };
        });
        if (campaign.name.indexOf('Copy') !== -1) {
          existentCopies = true;
        } else {
          campaignDropdowns.formats.push({
            campaignName: `${campaign.name}\n(${campaignFormats[objective]})`,
            campaignid: campaignId,
            adsets: campAdsets
          });
        }

        const campaignToReport = {
          value: campaignIdFromCall,
          text: campaignFormats[objective],
          name: campaignName
        };

        return Promise.resolve(campaignToReport);
      })
    );

    const newLogText = notCleanLog ? logText : '';

    this.setState({
      ...this.state,
      existentCopies,
      allCampaigns,
      logText: newLogText,
      campaignsFilterFormats: campaignDropdowns
    });
  };

  handleFilterChange = (event, adsetids, campaignId, isChange) => {
    const formats = this.state.campaignsFilterFormats.formats;
    adsetids.forEach((adsetid) => {
      const campaignObj = formats.filter((c) => {
        return c.campaignid === campaignId;
      })[0];
      const adsetObj = campaignObj.adsets.filter((adset) => {
        return adset.id === adsetid;
      })[0];
      adsetObj.selected = isChange;
    });
    const validCampaignSelection =
      formats.filter((f) => f.adsets.filter((a) => a.selected).length > 0)
        .length > 0;
    this.setState({
      campaignsFilterFormats: {
        formats
      },
      validCampaignSelection
    });
  };

  mapSelectedValues = (format) => {
    const selected = format.adsets
      .filter((adset) => {
        return adset.selected;
      })
      .map((adset) => {
        return adset.id;
      });

    return selected;
  };

  renderFormatDropdown = (format) => {
    const options = format.adsets.map((adset) => {
      return {
        key: adset.id,
        value: adset.id,
        text: adset.name
      };
    });
    return (
      <Grid.Column>
        <span>{format.campaignName}</span>
        <div style={{ maxWidth: 300 }} className="flipper-campaign-filter">
          <Dropdown
            placeholder={format.campaignName}
            value={this.mapSelectedValues(format)}
            onChange={(event, data) =>
              this.handleFilterChange(
                event,
                data.value,
                format.campaignid,
                true
              )
            }
            onLabelClick={(event, data) =>
              this.handleFilterChange(
                event,
                [data.value],
                format.campaignid,
                false
              )
            }
            disabled={this.state.processing}
            fluid
            multiple
            search
            selection
            options={options}
          />
        </div>
      </Grid.Column>
    );
  };

  renderCampaignDropdownFilters = () => {
    if (this.state.showCampaignSelector) {
      const formats = this.state.campaignsFilterFormats.formats;

      const formatChunks = formats.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / 5);

        if (!resultArray[chunkIndex]) {
          // eslint-disable-next-line no-param-reassign
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);

      return (
        <Grid columns={5}>
          {formatChunks.map((chunk) => (
            <Grid.Row>
              {chunk.map((format) => (
                <Grid.Column>{this.renderFormatDropdown(format)}</Grid.Column>
              ))}
            </Grid.Row>
          ))}
        </Grid>
      );
    } else if (this.state.showCampaignsLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };

  queryCampaigns = async (id) => {
    const { token } = this.state;
    const campaigns = await getCampaignsWithoutAdsets(id, token);
    const result = campaigns.data || [];

    const assocCampaigns = [];
    const campaignMonths = [];
    const years = [];

    map(orderBy([...result], ['start_time'], ['desc']), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);
      assocCampaigns[year + month] = {
        month_year: null,
        ids: []
      };
    });

    map(orderBy([...result], ['start_time'], ['desc']), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);

      const existentYear = years.filter((item) => {
        return item.text === year;
      });

      if (existentYear.length === 0) {
        years.push({
          value: year,
          text: year
        });
      }

      assocCampaigns[year + month].month = month;
      assocCampaigns[year + month].year = year;
      assocCampaigns[year + month].ids.push(campaign.id);
    });

    mapKeys(assocCampaigns, (month) => {
      if (month) {
        campaignMonths.push(month);
      }
    });

    const campaignOptions = map(campaignMonths, (op, index) => {
      const month = months.filter((item) => {
        return item.shortName === op.month;
      });

      return {
        key: index,
        value: op.ids.join(','),
        text: month[0] ? month[0].monthName : op.month,
        accountId: id,
        year: op.year
      };
    });

    const monthsOpt = map(campaignOptions, (op) => {
      return {
        value: op.text,
        text: op.text,
        campaignsIds: op.value,
        year: op.year
      };
    });

    const filteredMonths = monthsOpt.filter(
      (m) => m.year === this.state.selectedYear
    );

    this.setState({
      selectedCampaigns: campaignOptions,
      filteredCampaigns: campaignOptions,
      data: result,
      years,
      months: monthsOpt,
      filteredMonths
    });

    return campaignOptions;
  };

  getCampaigns = async (id) => {
    try {
      this.setState({
        campaigns: [],
        showYearLoader: true
      });
      const campaigns = await this.queryCampaigns(id);
      this.setState({
        campaigns: this.state.selectedCampaigns,
        showYearSelector: true,
        showYearLoader: false
      });
      return campaigns;
    } catch (error) {
      console.log('Error in getCampaigns(Flipper):', error);
      return [];
    }
  };

  cloneAds = async (adset, newDates, newAdSetId, newCampaignId, campaignId) => {
    const token = this.props.getFbToken();
    const allAds = await Promise.all(
      adset.ads.data.map(async (ad) => {
        const newAdName = replaceYearAndMonth(ad.name, newDates);

        const adData = {
          name: newAdName,
          adset_id: newAdSetId,
          ad: ad.id
        };
        await copyAd(adData, token).then(async (result) => {
          let newAdId = result.copied_ad_id;
          let attempts = 0;

          while (!newAdId && attempts !== 2) {
            attempts = attempts + 1;
            await copyAd(adData, token).then(async (copyAdResult) => {
              newAdId = copyAdResult.copied_ad_id;
            });
          }

          if (newAdId) {
            const currentAdLineage = {
              adId: ad.id,
              accountId: this.state.adAccountId,
              parentDealer: this.state.adAccountName,
              campaignId,
              adsetId: adset.id,
              adName: ad.name,
              month: newDates.month,
              year: newDates.year,
              createdAt: new Date(),
              username: this.props.user.email,
              parentAdId: ad.id,
              parentPackage: 'Managed Service',
              parentLanguage: 'English',
              parentEvent: 'None'
            };
            const newAdLineage = {
              adId: newAdId,
              accountId: this.state.adAccountId,
              parentDealer: this.state.adAccountName,
              campaignId: newCampaignId,
              adsetId: newAdSetId,
              adName: newAdName,
              month: newDates.newMonth,
              year: newDates.newYear,
              createdAt: new Date(),
              username: this.props.user.email,
              parentAdId: ad.id,
              parentPackage: 'Managed Service',
              parentLanguage: 'English',
              parentEvent: 'None'
            };
            await this.createLineage(currentAdLineage, newAdLineage);

            const adDataUpdate = {
              id: newAdId,
              name: newAdName,
              status: ad.status
            };

            if (ad.creative && ad.creative.object_story_spec) {
              const objectStorySpec = ad.creative.object_story_spec;
              const updated = this.renameObjectStorySpec(
                objectStorySpec,
                newAdName
              );

              if (
                objectStorySpec.link_data &&
                objectStorySpec.link_data.child_attachments &&
                objectStorySpec.link_data.child_attachments.length
              ) {
                objectStorySpec.link_data.child_attachments = objectStorySpec.link_data.child_attachments.map(
                  (childAttachment) => {
                    const tempChildAttachment = childAttachment;
                    if (
                      tempChildAttachment.image_hash &&
                      tempChildAttachment.picture
                    ) {
                      delete tempChildAttachment.image_hash;
                    }
                    return tempChildAttachment;
                  }
                );
              }

              if (updated) {
                adDataUpdate.creative = ad.creative;
                adDataUpdate.creative.object_story_spec = objectStorySpec;                
                adDataUpdate.url_tags = ad.creative.url_tags;
              }
            }

            this.setState({
              logText: `${this.state.logText}AD: "${ad.name}" changed to: "${newAdName}"\n`
            });

            if (!adDataUpdate.creative) {
              adDataUpdate.creative = ad.creative;
            }
            adDataUpdate.creative.degrees_of_freedom_spec =
            {
              creative_features_spec: {
                standard_enhancements: {
                  enroll_status: 'OPT_OUT'
                }
              }
            };
            const renamedAdData = this.renameCopyField(adDataUpdate);

            let attemptsUpdate = 0;
            let resultUpdateAd = await updateAd(renamedAdData, token);
            while (resultUpdateAd.status !== 200 && attemptsUpdate !== 3) {
              if (attemptsUpdate > 0) {
                const newLogText = `${this.state.logText}\n${ad.name} failed to Copy. Retrying now...\n\n`;
                this.setState({
                  ...this.state,
                  logText: newLogText
                });
              }
              attemptsUpdate = attemptsUpdate + 1;
              await updateAd(renamedAdData, token).then(
                async (updateAdResult) => {
                  resultUpdateAd = updateAdResult;
                }
              );
            }

            if (resultUpdateAd.status !== 200) {
              const newLogText = `${this.state.logText}\n\n${ad.name} was not changed in Facebook...Please rename!\n\n`;
              this.setState({
                ...this.state,
                logText: newLogText
              });
            }

            return Promise.resolve(resultUpdateAd);
          }
          const errMsg =
            result && result.error
              ? `${result.error.message} ${result.error.error_user_msg}`
              : 'Unknown error.';
          this.setState({
            errors: `${this.state.errors}ERROR AD: "${adset.name}" failed to be copied: "${errMsg}"\n`
          });
        });
        return Promise.resolve(ad);
      })
    );
    return allAds;
  };

  renameCopyField = (adDataUpdate) => {
    const adDataUpdateToUse = adDataUpdate;
    if (
      adDataUpdate.creative.object_story_spec &&
      adDataUpdate.creative.object_story_spec.video_data
    ) {
      adDataUpdateToUse.creative.object_story_spec.video_data.message += ' ';
      if (
        adDataUpdateToUse.creative.object_story_spec.video_data.image_url &&
        adDataUpdateToUse.creative.object_story_spec.video_data.image_hash
      ) {
        adDataUpdateToUse.creative.object_story_spec.video_data.image_hash = null;
      }
    }

    if (
      adDataUpdateToUse.creative.object_story_spec &&
      adDataUpdateToUse.creative.object_story_spec.link_data
    ) {
      adDataUpdateToUse.creative.object_story_spec.link_data.message += ' ';
    }

    if (
      adDataUpdateToUse.creative.object_story_spec &&
      adDataUpdateToUse.creative.object_story_spec.template_data
    ) {
      adDataUpdateToUse.creative.object_story_spec.template_data.message += ' ';
    }
    return adDataUpdateToUse;
  };

  getMapName = (adName) => {
    const staticRemoveText = 'Mobile Only_Canvas_';
    const cleanName = adName.substring(
      adName.indexOf(staticRemoveText) + staticRemoveText.length
    );
    const splitedName = cleanName.split(' ');
    const firstSectionText = splitedName[0];
    return `${cleanName.replace(
      `${firstSectionText} `,
      `${firstSectionText}_`
    )}_`;
  };

  cloneAdsets = async (newDates, campaign, newCampaignId) => {
    const startTime = `${newDates.newYear}-${newDates.newMonthInfo.monthNumber}-1 ${newDates.newMonthInfo.startHour}:00:00-07:00`;
    const endTime = `${newDates.newYear}-${newDates.newMonthInfo.monthNumber}-${newDates.newMonthInfo.endDay} ${newDates.newMonthInfo.endHour}:00:00-07:00`;
    const token = this.props.getFbToken();
    const formatCampaign = this.state.campaignsFilterFormats.formats.filter(
      (c) => c.campaignid === campaign.id
    )[0];
    const selectedAdSets = formatCampaign.adsets
      .filter((a) => a.selected)
      .map((a) => a.id);

    const allAdSets = await Promise.all(
      campaign.adsets.map(async (adset) => {
        if (selectedAdSets.indexOf(adset.id) >= 0) {
          const adSetData = {
            campaign_id: newCampaignId,
            start_time: startTime,
            end_time: endTime,
            adset: adset.id
          };

          // eslint-disable-next-line no-unused-vars
          let adsCloned = null;

          await copyAdSet(adSetData, token).then(async (result) => {
            let recopy = false;
            let newAdSetId = result.copied_adset_id;
            let attempts = 0;

            while (
              !newAdSetId &&
              result.error &&
              result.error.error_user_title === 'Budget Is Too Low' &&
              attempts !== 2
            ) {
              attempts = attempts + 1;
              recopy = true;
              const startDateParts = adset.start_time.split('T')[0];
              const endDateParts = adset.end_time.split('T')[0];
              const startDay = startDateParts.substring(
                startDateParts.length - 2
              );
              let endDay = endDateParts.substring(endDateParts.length - 2);
              if (newDates.currentMonth.endDay === endDay) {
                endDay = newDates.newMonthInfo.endDay;
              }

              adSetData.start_time = `${newDates.newYear}-${newDates.newMonthInfo.monthNumber}-${startDay} ${newDates.newMonthInfo.startHour}:00:00-07:00`;
              adSetData.end_time = `${newDates.newYear}-${newDates.newMonthInfo.monthNumber}-${endDay} ${newDates.newMonthInfo.endHour}:00:00-07:00`;

              await copyAdSet(adSetData, token).then(
                async (copyAdSetResult) => {
                  newAdSetId = copyAdSetResult.copied_adset_id;
                }
              );
            }

            while (!newAdSetId && attempts !== 2) {
              attempts = attempts + 1;
              await copyAdSet(adSetData, token).then(
                async (copyAdSetResult) => {
                  newAdSetId = copyAdSetResult.copied_adset_id;
                }
              );
            }

            if (newAdSetId) {
              const newAdSetName = replaceYearAndMonth(adset.name, newDates);

              if (adset && adset.ads && adset.ads.data) {
                const { isDeleteAdsToggleChecked } = this.state;

                if (isDeleteAdsToggleChecked) {
                  const adsToggleFilter = JSON.parse(JSON.stringify(adset));

                  adsToggleFilter.ads.data = [];

                  const ads = adset.ads.data;
                  ads.forEach((ad) => {
                    const name = ad.name.split('_');
                    const objective = name[3];
                    const adTemplate = name[7];
                    if (name.length > 6) {
                      const keepAd =
                        objective.includes('DAA') || adTemplate.includes('CR');

                      if (keepAd) {
                        adsToggleFilter.ads.data.push(ad);
                      }
                    }
                  });
                  adsCloned = await this.cloneAds(
                    adsToggleFilter,
                    newDates,
                    newAdSetId,
                    newCampaignId,
                    campaign.id
                  );
                } else {
                  adsCloned = await this.cloneAds(
                    adset,
                    newDates,
                    newAdSetId,
                    newCampaignId,
                    campaign.id
                  );
                }
              }

              const adSetDataUpdate = {
                id: newAdSetId,
                name: newAdSetName
              };

              this.setState({
                logText: `${this.state.logText}ADSET: "${adset.name}" changed to: "${newAdSetName}"\n`
              });

              if (!recopy) {
                this.setState({
                  logText: `${
                    this.state.logText
                  }"ADSET: Dates for "${newAdSetName}" have been updated from "${formatDateTime(
                    startTime
                  )}" to: "${formatDateTime(endTime)}"\n`
                });
              } else {
                this.setState({
                  warnings: `${
                    this.state.warnings
                  }"WARNING ADSET "${newAdSetName}" is running from "${formatDateTime(
                    adSetData.start_time
                  )}" to: "${formatDateTime(adSetData.end_time)}"\n`
                });
              }

              let attemptsUpdate = 0;
              let resultUpdateAdset = await updateAdSet(adSetDataUpdate, token);
              while (resultUpdateAdset.status !== 200 && attemptsUpdate !== 2) {
                attemptsUpdate = attemptsUpdate + 1;
                await updateAdSet(adSetDataUpdate, token).then(
                  async (updateAdSetResult) => {
                    resultUpdateAdset = updateAdSetResult;
                  }
                );
              }
              return Promise.resolve(resultUpdateAdset);
            }
            const errMsg =
              result && result.error
                ? `${result.error.message} ${result.error.error_user_msg}`
                : 'Unknown error.';
            this.setState({
              errors: `${this.state.errors}ERROR ADSET: "${adset.name}" failed to be copied: "${errMsg}"\n`
            });
          });
        }
        return Promise.resolve();
      })
    );
    return Promise.resolve(allAdSets);
  };

  generateNewDates = (campaign) => {
    const { newSelectedMonth, newSelectedYear } = this.state;
    const campaignNameParts = campaign.name.split('_');
    const year = getYearFromCampaign(campaign) || campaignNameParts[0];
    const month = getMonthFromCampaign(campaign) || campaignNameParts[1];

    let newYear = year;
    let newMonth = month;
    let newMonthInfo;

    const currentMonth = months.filter((val) => {
      const lowerCaseMonth = month.toLowerCase();
      const lowerCaseShortName = val.shortName.toLowerCase();
      return lowerCaseMonth.includes(lowerCaseShortName);
    })[0];

    const { shortName: currentShortName = '' } = currentMonth || {};

    if (parseInt(year, 10) % 4 === 0 && currentShortName === 'Feb') {
      currentMonth.endDay = 29;
    }

    if (newSelectedMonth !== null && newSelectedYear !== null) {
      newYear = newSelectedYear;
      newMonthInfo = newSelectedMonth.monthObj;
      newMonth = newMonthInfo.shortName;
    } else if (month === 'Dec') {
      newYear = parseInt(year, 10) + 1;
      newMonth = 'Jan';
      newMonthInfo = months.filter((val) => val.shortName === newMonth)[0];
    } else {
      const monthNumber =
        months.filter((val) => val.shortName === month)[0].monthNumber + 1;
      newMonthInfo = months.filter((val) => {
        return val.monthNumber === monthNumber;
      })[0];
      newMonth = newMonthInfo.shortName;
    }

    if (
      newMonthInfo &&
      newMonthInfo.shortName === 'Feb' &&
      parseInt(newYear, 10) % 4 === 0
    ) {
      newMonthInfo.endDay = 29;
    }

    return {
      year,
      month,
      newYear,
      newMonth,
      newMonthInfo,
      currentMonth
    };
  };

  cloneCampaign = async (campaign, newDates) => {
    const { id, name, special_ad_categories: specialAdCategory } = campaign;
    const token = this.props.getFbToken();
    const result = await copyCampaign(id, token);
    const newCampaignId = result.copied_campaign_id;

    const campaignName = replaceYearAndMonth(name, newDates);

    const campaignData = {
      id: newCampaignId,
      name: campaignName,
      special_ad_categories: specialAdCategory
    };

    await updateCampaign(campaignData, token);
    this.setState({
      logText: `${this.state.logText}CAMPAIGN: "${campaign.name}" changed to: "${campaignName}"\n`
    });

    return newCampaignId;
  };

  flipper = () => {
    this.setState(
      (prevState) => ({ ...prevState, notCleanLog: true }),
      () => {
        const { adAccountId } = this.state;
        clearFbCacheInLocalStorage();
        this.flipCampaign().then(() => {
          this.queryCampaigns(adAccountId).then(() => {
            this.setState((prevState) => ({
              ...prevState,
              processing: false,
              processingText: '',
              done: true,
              notCleanLog: false
            }));
          });
        });
      }
    );
  };

  getCampaignsFromState = (formats) => {
    const campaignWithAdsets = formats.filter((f) => {
      const selectedAdsets = f.adsets.filter((a) => a.selected);
      return selectedAdsets.length > 0;
    });

    return campaignWithAdsets.map((ca) => ca.campaignid);
  };

  flipCampaign = async () => {
    this.setState({
      logText: '',
      errors: '',
      warnings: '',
      processing: true,
      processingText: 'Creating Campaigns...',
      done: false,
      nextStepFlipperAds: {
        sourceAds: [],
        targetAds: []
      }
    });

    // eslint-disable-next-line no-unused-vars
    let allAdSets = null;

    const campaignIds = this.getCampaignsFromState(
      this.state.campaignsFilterFormats.formats
    );
    const token = this.props.getFbToken();
    const allCampaigns = await this.getCampaignsInfo(token, true);
    await Promise.all(
      allCampaigns.map(async (campaign) => {
        const selectedCampaign = campaignIds.find((item) => {
          return item === campaign.id;
        });
        if (campaign && selectedCampaign) {
          const newDates = this.generateNewDates(campaign);
          const newCampaignId = await this.cloneCampaign(campaign, newDates);
          allAdSets = await this.cloneAdsets(newDates, campaign, newCampaignId);
        }
      })
    );

    this.cleanLog();
  };

  getRefreshedCampaignsIds = async () => {
    await this.queryCampaigns(this.state.adAccountId);
    const campaignName = this.state.campaignName;
    const campaign = find(this.state.selectedCampaigns, (option) => {
      return option.text === campaignName;
    });

    return campaign.value.split(',');
  };

  getCampaignsInfo = async (token, returnAll) => {
    let existentCopies = this.state.existentCopies;
    const campaignIds = await this.getRefreshedCampaignsIds();

    const allCampaigns = await Promise.all(
      map(campaignIds, async (campaignId) => {
        const campaign = await getCampaign(campaignId, token);
        if (returnAll || campaign.name.indexOf('Copy') !== -1) {
          if (campaign.name.indexOf('Copy') !== -1) {
            existentCopies = true;
          }
          const campaignToReport = await this.createCampaignToReport(
            campaign,
            token
          );
          return Promise.resolve(campaignToReport);
        }
      })
    );

    this.setState({
      existentCopies
    });
    return allCampaigns;
  };

  cleanLog = () => {
    if (!this.state.notCleanLog) {
      this.setState({
        logText: '',
        errors: '',
        warnings: '',
        done: false
      });
    }
    const client = window.__APOLLO_CLIENT__;
    client.resetStore();
  };

  // Replace all matching last dates for current month with its corresponding upcoming last date.
  replaceLastDateWithUpcoming = (text, month, year) => {
    const { newSelectedMonth, newSelectedYear } = this.state;
    let updatedText = text;
    const shortYear = year.toString().substring(2);
    const currentMonth = months.find(
      (item) =>
        item.monthName === month || item.shortName === month.substring(0, 3)
    );
    const { monthNumber: currentMonthNumber, endDay: currentMonthEndDay } =
      currentMonth || {};
    const monthNumber =
      currentMonthNumber && currentMonthNumber < 10
        ? `0${currentMonthNumber}`
        : currentMonthNumber.toString();

    const spanishLastDate = `${currentMonthEndDay}/${monthNumber}/${year}`;
    const englishLastDate = `${monthNumber}/${currentMonthEndDay}/${year}`;
    const spanishLastDateShortMonth = `${currentMonthEndDay}/${currentMonthNumber}/${year}`;
    const englishLastDateShortMonth = `${currentMonthNumber}/${currentMonthEndDay}/${year}`;
    const spanishLastDateShortYear = `${currentMonthEndDay}/${monthNumber}/${shortYear}`;
    const englishLastDateShortYear = `${monthNumber}/${currentMonthEndDay}/${shortYear}`;
    const spanishLastDateShortYearMonth = `${currentMonthEndDay}/${currentMonthNumber}/${shortYear}`;
    const englishLastDateShortYearMonth = `${currentMonthNumber}/${currentMonthEndDay}/${shortYear}`;

    if (newSelectedMonth !== null && newSelectedYear !== null) {
      const { monthObj } = newSelectedMonth || {};
      const { monthNumber: monthObjNumber, endDay: monthObjEndDay } =
        monthObj || {};
      const newMonthNumber =
        monthObjNumber && monthObjNumber > 9
          ? monthObjNumber
          : `0${monthObjNumber}`;
      const newLastDateSpanish = `${monthObjEndDay}/${newMonthNumber}/${newSelectedYear}`;
      const newLastDateEnglish = `${newMonthNumber}/${monthObjEndDay}/${newSelectedYear}`;
      updatedText = text.replace(
        new RegExp(spanishLastDate, 'g'),
        newLastDateSpanish
      );
      updatedText = text.replace(
        new RegExp(englishLastDate, 'g'),
        newLastDateEnglish
      );
      updatedText = text.replace(
        new RegExp(spanishLastDateShortMonth, 'g'),
        newLastDateSpanish
      );
      updatedText = text.replace(
        new RegExp(englishLastDateShortMonth, 'g'),
        newLastDateEnglish
      );
      updatedText = text.replace(
        new RegExp(spanishLastDateShortYear, 'g'),
        newLastDateSpanish
      );
      updatedText = text.replace(
        new RegExp(englishLastDateShortYear, 'g'),
        newLastDateEnglish
      );
      updatedText = text.replace(
        new RegExp(spanishLastDateShortYearMonth, 'g'),
        newLastDateSpanish
      );

      const indexOfDateString = text.indexOf(englishLastDateShortYearMonth);

      if (indexOfDateString !== -1) {
        const finalIndex =
          text[indexOfDateString - 1].trim() === ''
            ? indexOfDateString
            : indexOfDateString - 1;

        updatedText = text.substring(0, finalIndex).concat(newLastDateEnglish);
      } else {
        updatedText = text.replace(
          new RegExp(englishLastDateShortYearMonth, 'g'),
          newLastDateEnglish
        );
      }

      return updatedText;
    }
    updatedText = text.replace(
      new RegExp(spanishLastDate, 'g'),
      getLastDateForUpcomingMonth(spanishLastDate)
    );
    updatedText = text.replace(
      new RegExp(englishLastDate, 'g'),
      getLastDateForUpcomingMonth(englishLastDate)
    );
    updatedText = text.replace(
      new RegExp(spanishLastDateShortMonth, 'g'),
      getLastDateForUpcomingMonth(spanishLastDate)
    );
    updatedText = text.replace(
      new RegExp(englishLastDateShortMonth, 'g'),
      getLastDateForUpcomingMonth(englishLastDate)
    );
    updatedText = text.replace(
      new RegExp(spanishLastDateShortYear, 'g'),
      getLastDateForUpcomingMonth(spanishLastDate)
    );
    updatedText = text.replace(
      new RegExp(englishLastDateShortYear, 'g'),
      getLastDateForUpcomingMonth(englishLastDate)
    );
    updatedText = text.replace(
      new RegExp(spanishLastDateShortYearMonth, 'g'),
      getLastDateForUpcomingMonth(spanishLastDate)
    );
    updatedText = text.replace(
      new RegExp(englishLastDateShortYearMonth, 'g'),
      getLastDateForUpcomingMonth(englishLastDate)
    );

    return updatedText;
  };

  createLineage = async (currentAd, newAd) => {
    let atleredNewAd = newAd;
    const { nextStepFlipperAds } = this.state;
    const adLineage = await getAdLineageByAdId(currentAd.adId);
    if (adLineage === null) {
      this.setState({
        newLineage: true
      });
      const newCurrentAdLineage = await insertAdLineage(currentAd);
      nextStepFlipperAds.sourceAds.push(newCurrentAdLineage);
    } else {
      const {
        parentAdId,
        parentCategory,
        parentPackage,
        parentLanguage,
        parentEvent,
        parentGroup,
        oemFocus
      } = adLineage;

      atleredNewAd = {
        ...newAd,
        parentAdId,
        parentCategory,
        parentPackage,
        parentLanguage,
        parentEvent,
        parentGroup,
        oemFocus
      };
      if (
        isNullOrUndefined(parentCategory) ||
        isNullOrUndefined(parentPackage) ||
        isNullOrUndefined(parentLanguage) ||
        isNullOrUndefined(parentGroup) ||
        isNullOrUndefined(oemFocus) ||
        isNullOrUndefined(parentEvent)
      ) {
        nextStepFlipperAds.sourceAds.push(adLineage);
        this.setState({
          newLineage: true
        });
      }
    }
    const newFlippedAdLineage = await insertAdLineage(atleredNewAd);
    nextStepFlipperAds.targetAds.push(newFlippedAdLineage);
  };

  createCampaignToReport = async (campaign, token) => {
    const {
      id: campaignId,
      start_time: startTime,
      created_time: createdTime,
      name: campaignName,
      special_ad_categories: specialAdCategory
    } = campaign;

    const campaignToReport = {
      id: campaignId,
      start_time: startTime,
      created_time: createdTime,
      name: campaignName,
      special_ad_categories: specialAdCategory,
      adsets: [],
      ads: []
    };

    if (campaign.adsets) {
      const adsets = await Promise.all(
        campaign.adsets.data.map(async (item) => {
          return Promise.resolve(await getAdSet(item.id, token));
        })
      );
      campaignToReport.adsets = adsets;
    }

    if (campaign.ads) {
      const ads = await Promise.all(
        campaign.ads.data.map(async (item) => {
          return Promise.resolve(await getAd(item.id, token));
        })
      );
      campaignToReport.ads = ads;
    }

    return campaignToReport;
  };

  renameObjectStorySpec = (objectStorySpec, newAdSetName) => {
    const { selectedYear, campaignName, logText } = this.state;
    const alteredObjectStorySpec = objectStorySpec;
    const year = selectedYear;
    const month = campaignName;
    let updated = false;
    let oldText = '';
    let newText = '';
    const {
      video_data: originalVideoData,
      link_data: originalLinkData,
      template_data: originalTemplateData
    } = objectStorySpec || {};
    const { link_description: originalVideoDataLinkDesc } =
      originalVideoData || {};
    const { description: originalLinkDataDesc } = originalLinkData || {};
    const { description: originalTemplateDataDesc } =
      originalTemplateData || {};

    if (objectStorySpec && originalVideoData && originalVideoDataLinkDesc) {
      updated = true;
      oldText = originalVideoDataLinkDesc;
      alteredObjectStorySpec.video_data.link_description = this.replaceLastDateWithUpcoming(
        objectStorySpec.video_data.link_description,
        month,
        year
      );
      newText = alteredObjectStorySpec.video_data.link_description;
    }

    if (objectStorySpec && originalLinkData && originalLinkDataDesc) {
      updated = true;
      oldText = originalLinkDataDesc;
      const newLinkData = originalLinkData;
      alteredObjectStorySpec.link_data.description = this.replaceLastDateWithUpcoming(
        objectStorySpec.link_data.description,
        month,
        year
      );
      if (newLinkData.picture && newLinkData.image_hash) {
        delete newLinkData.image_hash;
      }
      alteredObjectStorySpec.link_data = newLinkData;
      newText = alteredObjectStorySpec.link_data.description;
    }

    if (objectStorySpec && originalTemplateData && originalTemplateDataDesc) {
      updated = true;
      oldText = originalTemplateDataDesc;
      alteredObjectStorySpec.template_data.description = this.replaceLastDateWithUpcoming(
        originalTemplateDataDesc,
        month,
        year
      );
      newText = alteredObjectStorySpec.template_data.description;
    }

    if (updated && oldText !== newText) {
      this.setState({
        ...this.state,
        logText: `${logText}"ADSET: Text for "${newAdSetName}" have been updated from "${oldText}" to: "${newText}"\n`
      });
    }

    return oldText !== newText;
  };

  renderMonthDropDown = () => {
    const {
      showMonthSelector,
      campaignName,
      processing,
      filteredMonths
    } = this.state;
    if (showMonthSelector) {
      return (
        <div>
          <Dropdown
            placeholder="Month"
            search
            selection
            value={campaignName}
            disabled={processing}
            options={filteredMonths}
            onChange={this.onCampaignSelect}
          />
        </div>
      );
    } else if (this.state.showMonthLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };
  flipToMonthChange = (event, { options, value }) => {
    const selectedMonth = find(options, (option) => {
      return option.value === value;
    });
    this.setState({
      newSelectedMonth: selectedMonth
    });
  };
  flipToYearChange = (event, { options, value }) => {
    const selectedYear = find(options, (option) => {
      return option.value === value;
    });
    this.setState({
      newSelectedYear: selectedYear.value
    });
  };

  toggleCheckedStatusForDeletingAds = () => {
    const { isDeleteAdsToggleChecked } = this.state;
    this.setState({
      ...this.state,
      isDeleteAdsToggleChecked: !isDeleteAdsToggleChecked
    });
  };

  renderArrowFlip = () => {
    const { showNextMonthYear } = this.state;
    if (showNextMonthYear) {
      return (
        <div className="flipper-arrow">
          <span>Flip To:</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="100%"
            height="20"
            viewBox="-0.709 -0.235 213 71"
            enableBackground="new -0.709 -0.235 213 71"
          >
            <defs />
            <polygon points="0,26.488 0,44.144 167.747,44.144 167.747,70.631 211.89,35.316 167.747,0 167.747,26.488 " />
          </svg>
        </div>
      );
    }
    return null;
  };
  renderNextMonthYearDropDown = () => {
    const {
      showNextMonthYear,
      processing,
      newSelectedMonth,
      newSelectedYear
    } = this.state;
    const monthsToFlip = months.map((month) => {
      return {
        value: month.monthName,
        text: month.monthName,
        monthObj: month,
        key: month.monthName
      };
    });
    const currentYear = new Date().getFullYear();
    const { value: newSelectedMonthValue } = newSelectedMonth || {};
    if (showNextMonthYear) {
      const yearsToFlip = [];
      for (let i = currentYear; i <= currentYear + 1; i += 1) {
        yearsToFlip.push({
          value: i.toString(),
          text: i,
          key: i
        });
      }
      return (
        <div>
          <Dropdown
            placeholder="Month To Flip"
            search
            selection
            disabled={processing}
            options={monthsToFlip}
            value={newSelectedMonthValue}
            onChange={this.flipToMonthChange}
          />
          <span> - </span>
          <Dropdown
            placeholder="Year To Flip"
            search
            selection
            disabled={processing}
            options={yearsToFlip}
            value={newSelectedYear}
            onChange={this.flipToYearChange}
          />
        </div>
      );
    }
    return null;
  };
  renderDoneOrNext = () => {
    const { done } = this.state;
    if (done) {
      return (
        <div className="processing-container">
          <span> Done</span>
        </div>
      );
    }
    return null;
  };
  renderYearSelector = () => {
    const {
      showYearSelector,
      processing,
      years,
      selectedYear,
      showYearLoader
    } = this.state;
    if (showYearSelector) {
      return (
        <Dropdown
          placeholder="Year"
          disabled={processing}
          search
          selection
          options={years}
          value={selectedYear}
          onChange={this.onYearSelect}
        />
      );
    } else if (showYearLoader) {
      return (
        <Container>
          <Loader inline className="active" />{' '}
        </Container>
      );
    }
    return null;
  };
  renderFlipperButton = () => {
    const {
      errors,
      warnings,
      logText,
      showFlipperButton,
      processing,
      existentCopies,
      validCampaignSelection,
      processingText
    } = this.state;
    const log = errors + warnings + logText;

    if (showFlipperButton) {
      return (
        <div>
          <Button
            disabled={processing || existentCopies || !validCampaignSelection}
            className="floated left tiny grey"
            onClick={() => this.flipper()}
          >
            Flip Campaign
          </Button>
          {!validCampaignSelection ? (
            <div className="processing-container">
              <span>Please select at least one adset to copy.</span>
            </div>
          ) : null}
          {processing ? (
            <div className="processing-container">
              <span>
                <Loader inline className="active" />
                {` ${processingText} `}
              </span>
            </div>
          ) : null}
          {this.renderDoneOrNext()}
          <Divider hidden />
          <TextArea
            className="debug-log"
            placeholder="Debug Log"
            disabled
            rows="18"
            value={log}
          />
        </div>
      );
    }
    return null;
  };
  render() {
    const {
      adAccountId,
      processing,
      accountOptions,
      refreshAccountsLoading,
      isDeleteAdsToggleChecked
    } = this.state;
    return (
      <div className="container">
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column>
              <div className="top-of-flipper-page">
                <div>
                  <Dropdown
                    placeholder="Ad Accounts"
                    search
                    selection
                    value={adAccountId}
                    disabled={processing}
                    options={accountOptions}
                    onChange={this.onAccountSelect}
                  />
                  <Button
                    basic
                    compact
                    loading={refreshAccountsLoading}
                    color="blue"
                    icon="refresh"
                    onClick={this.refreshAccounts}
                    style={{ marginLeft: '1%' }}
                  />
                </div>
                <Checkbox
                  label="Delete Ads"
                  toggle
                  onChange={() => this.toggleCheckedStatusForDeletingAds()}
                  checked={isDeleteAdsToggleChecked}
                />
              </div>
              <Divider hidden />
              {this.renderYearSelector()}
              <Divider hidden />
              <Grid>
                <Grid.Row columns={3}>
                  <Grid.Column width={3}>
                    {this.renderMonthDropDown()}
                  </Grid.Column>
                  <Grid.Column width={1}>{this.renderArrowFlip()}</Grid.Column>
                  <Grid.Column width={8}>
                    {this.renderNextMonthYearDropDown()}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider hidden />
              {this.renderCampaignDropdownFilters()}
              <Divider hidden />
              {this.renderFlipperButton()}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps, null)(FlipperSync);



// WEBPACK FOOTER //
// ./src/screens/Flipper/FlipperSync.js